<!-- 由 woniu6162 创建于 2020-12-04 星期五 -->
<template>
  <div class="p-success">
    <van-icon name="checked" color="#74d8c8" size="17.1vw" />
    <div class="ps_title">提交成功</div>
    <div class="ps_sub">感谢您的填写</div>
    <div class="ps_line" />
    <div v-html="info" class="ps_info" />
    <div class="ps_sure" @click="tapSure">确定</div>
  </div>
</template>

<script>
export default {
  name: 'p-success',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      info: '您的信息已经上传成功<br/>如果您已经购买了一对一减脂营<br/>您可以联系小助理确认您参与的营期<br/>避免错过减脂营开营哟～'
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    tapSure() {
      if (this.$betterwe.isApp()) {
        window.history.go(-1)
      } else {
        window['wx']['closeWindow']()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.p-success {
  height: 100vh;
  padding-top: 16.3vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ps_title {
    margin-top: 5.9vw;
    font-size: 6.4vw;
    font-weight: 600;
    color: #000;
  }
  .ps_sub {
    margin-top: 0.5vw;
    font-size: 3.7vw;
    line-height: 6.4vw;
    color: rgba(0, 0, 0, 0.8);
  }
  .ps_line {
    margin: 4vw auto;
    width: 69.1vw;
    height: 0.3vw;
    background: #f7f7f7;
  }
  .ps_info {
    font-size: 3.2vw;
    line-height: 6.4vw;
    color: rgba(0, 0, 0, 0.5);
  }
  .ps_sure {
    margin-top: 42.7vw;
    width: 70.4vw;
    height: 10.1vw;
    background-color: #74d8c8;
    border-radius: 1.1vw;
    font-size: 4vw;
    font-weight: 600;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
